export const AT_CHANGE_VIEW = 'at_change_view';

const initialState = { changes: null };

export const atChangeView = changeConfig => ({
  type: AT_CHANGE_VIEW,
  payload: changeConfig,
  viewName: changeConfig.viewName
});

export default function(state = initialState, action) {
  switch (action.type) {
    case AT_CHANGE_VIEW:
      return {
        ...state,
        [action.viewName]: action.payload
      };
    default:
      return state;
  }
}
